// extracted by mini-css-extract-plugin
module.exports = {"modal":"common_modal__1D0N0","inner-container":"common_inner-container__sGYoh","dialog-content":"common_dialog-content__aCFx1"};